import { FieldProps } from '../type/form';
import XMarkCircleFill from 'icon/xmark_circle_fill.svg';
import cls from 'classnames';
import { useContext, useEffect, useRef, useState } from 'react';
import { FormContext, FormItem } from '../../form';

import './style.scss';

export function FormInput(props: FieldProps) {
  const {
    name,
    label,
    placeHolder,
    tip,
    prefix,
    prompt,
    className = '',
    required,
    maxLength,
    rules,
    group,
    defaultValue = '',
    disabled = false,
  } = props;

  const { dispatch } = useContext(FormContext);
  const [value, setValue] = useState('');
  // 控制是否聚焦，显示清空按钮
  const [isFocus, setIsFocus] = useState(false);
  const formInputRef = useRef<HTMLInputElement>(null);

  // 默认值
  useEffect(() => {
    setValue(defaultValue as string);
    dispatch({ name, type: 'change', payload: defaultValue });
  }, [defaultValue, dispatch, name]);

  // 输入框内的value改变
  function handleInputChange(event: any) {
    const inputValue = event.target.value;
    setValue(inputValue);
  }

  // 清除输入框的输入
  function handleCleanInput() {
    dispatch({ name, type: 'change', payload: '' });
    setValue('');
    // 在失去焦点事件后，再重新focus
    setTimeout(() => {
      formInputRef.current?.focus();
    }, 20);
  }

  // 输入框聚焦
  function handleInputFocus() {
    // 由于form使用的是通过dispatch将它重新渲染
    setIsFocus(true);
  }

  // 失去焦点
  function handleInputBlur() {
    // 如果要是触发清空，要先清空再进行失去焦点事件
    setTimeout(() => {
      setIsFocus(false);
    });
  }

  return (
    <FormItem
      {...{
        name,
        label,
        tip,
        prefix,
        prompt,
        className,
        required,
        group,
        rules,
      }}
    >
      <div className={cls('form-input', { disabled })}>
        <input
          placeholder={placeHolder}
          maxLength={maxLength}
          className={cls('form-input-container', { 'input-focus': isFocus })}
          value={value}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          ref={formInputRef}
          disabled={disabled}
        />
        {isFocus && (
          <div className="right-area" onMouseDown={handleCleanInput}>
            <XMarkCircleFill className="x-mark-circle-icon" />
          </div>
        )}
      </div>
    </FormItem>
  );
}
